export default function mimeType(extension) {
    var mime_type = "___";
    if (extension == "jpg" || extension == "jpeg") {
        mime_type = "image/jpeg"
    } else if (extension == "png") {
        mime_type = "image/png"
    }   
    return mime_type
}